import { ASSET_PREFIX } from 'utils/constants';

interface IRetroIconSVG {
  fname: string;
  className?: string;
  alt?: string;
}

const RetroIconSVG = ({ fname, className = '', alt = ''}: IRetroIconSVG) => {
  return (
    <img
      className={`retroIconSVG ${className}`}
      src={`${ASSET_PREFIX}/images/token-town/${fname}.svg`}
      alt={alt}
    />
  );
};

export default RetroIconSVG;
